const types = {
    LOAD_MENU: 'LOAD_MENU',
    LOAD_CURRENT_MENU: 'LOAD_CURRENT_MENU',
    TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
    TOGGLE_SIDEBAR_SHOW: 'TOGGLE_SIDEBAR_SHOW',
    SET_ROUTERS:  'SET_ROUTERS',
    SET_TOKEN: 'SET_TOKEN',
    REMOVE_TOKEN: 'REMOVE_TOKEN',
    SET_OTHERROUTERS: 'SET_OTHERROUTERS'
}
export default types;